import { render, staticRenderFns } from "./TheFooterNavbar.vue?vue&type=template&id=25ca3cca&"
import script from "./TheFooterNavbar.vue?vue&type=script&lang=js&"
export * from "./TheFooterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TheFooterNavbar.vue?vue&type=style&index=0&id=25ca3cca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports